module.exports = __webpack_public_path__ + "static/media/pool-hall10.2b36f9f6.jpg";